ixModuleRouting("impactx.numberingscheme", {
    "/numberingschemelist": {
        template: "<ixa-numberingscheme-list></ixa-numberingscheme-list>",
        templateUrl:
            "modules/numberingscheme/templates/numberingschemelist.html",
        controller: "NumberingSchemeListCtrl",
        controllerAs: "numberingSchemeListCtrl",
        process: "NumberingScheme",
        workspace: "content",
    },
    "/numberingscheme/:id": {
        template: "<ixa-numberingscheme></ixa-numberingscheme>",
        templateUrl: "modules/numberingscheme/templates/numberingscheme.html",
        controller: "NumberingSchemeCtrl",
        controllerAs: "numberingSchemeCtrl",
        process: "NumberingScheme",
        workspace: "content",
    },
});
